module.exports = {
  oneClick: {
    saveCardCheckboxLabel: 'Me gustaría guardar estos datos para futuras compras.',
    cardInfoLabel: '{brand} últimos {lastFour}',
    newCreditCardLabel: 'Usar otra tarjeta de crédito',
  },
  creditcardButtonMessage: 'Pagar con tarjeta de crédito',
  debitcardButtonMessage: 'Pagar con tarjeta de débito',
  externalpayproviderButtonMessage: 'Pagar con Fawry',
  banktransferButtonMessage: 'Pagar con transferencia bancaria',
  cardNumberLabel: 'Número de la tarjeta',
  methodName: {
    creditcard: 'Tarjeta de Crédito',
    debitcard: 'Tarjeta de Débito',
    externalpayprovider: 'Inmediato',
    paymob: 'Mobile Wallet',
  },
  info: {
    paymob: {
      payButton: 'Pagar con billetera móvil',
      phoneNumber: 'Después de confirmar, serás redirigido automáticamente a tu billetera.',
      title: 'Consulta las billeteras móviles que aceptamos:',
      description: 'ABK Wallet, ADCB Wallet, AIB Wallet, Ameen, Audi2Pay, Banki Wallet, BLOM Wallet, BM Wallet, Cashati, Easy Cash, Etisalat Cash, E-Pocket, Faisal Cash, Floussy, GEBE, Halan Cash, Ma7fazty, NBK Wallet, Orange Cash, Phone Cash, Qahera Cash, QNB Wallet, SCB E-Wallet, Smart Wallet, UB Wallet, Vodafone Cash, We Pay, 3altayer.',
    },
  },
};
